import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";

const Sizecomponent = () => {
  const [sizeCharts, setSizeCharts] = useState([]);

  const fetchSizeCharts = async () => {
    try {
      const res = await fetch(getApiUrl("getcharts"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({})
      });

      const result = await res.json();
      if (result.success) {
        setSizeCharts(result.data);
      }
    } catch (error) {
      console.log("Failed to fetch size charts");
    }
  };

  useEffect(() => {
    fetchSizeCharts();
  }, []);

  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-center page-title">Size Charts</h3>

      {sizeCharts.length > 0 ? (
        sizeCharts.map((chart) => {
          const hasField = (field) =>
            chart.sizes?.some((item) => item[field] && item[field] !== "");

          return (
            <div key={chart._id} className="size-card mb-5">
              <h5 className="chart-title">{chart.chartName}</h5>

              <div className="table-responsive-custom">
                <table className="table shadow-table">
                  <thead>
                    <tr>
                      <th>Size</th>
                      {hasField("bust") && <th>Bust</th>}
                      {hasField("waist") && <th>Waist</th>}
                      {hasField("hip") && <th>Hip</th>}
                      {hasField("topLength") && <th>Top Length</th>}
                      {hasField("pantLength") && <th>Pant Length</th>}
                      {hasField("thigh") && <th>Thigh</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {chart.sizes?.length > 0 ? (
                      chart.sizes.map((item, index) => (
                        <tr key={index}>
                          <td>{item.size}</td>
                          {hasField("bust") && <td>{item.bust || "-"}</td>}
                          {hasField("waist") && <td>{item.waist || "-"}</td>}
                          {hasField("hip") && <td>{item.hip || "-"}</td>}
                          {hasField("topLength") && <td>{item.topLength || "-"}</td>}
                          {hasField("pantLength") && <td>{item.pantLength || "-"}</td>}
                          {hasField("thigh") && <td>{item.thigh || "-"}</td>}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No size details found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })
      ) : (
        <p className="text-center">No size charts found.</p>
      )}
    </div>
  );
};

export default Sizecomponent;
